import TabComponent from "./TabComponent";


export default TabComponent